// extracted by mini-css-extract-plugin
module.exports = {"title":"Description__title--Mkp","body":"Description__body--35r"};